import React from 'react';
import { Container } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { Link, useParams } from 'react-router-dom';
import MeasurementUnitForm from '../../Components/MeasurementUnits/MeasurementUnitForm';

/**
 * Component for editing an existing measurement unit
 * @returns {JSX.Element}
 */
const MeasurementUnitEdit = () => {
  const { lng, id } = useParams();

  return (
    <Container fluid>
      <div className="page-header">
        <div className="page-title">
          <h4>Edit Measurement Unit</h4>
          <h6>Update measurement unit details</h6>
        </div>
        <div className="page-btn">
          <Link to={`/${lng}/settings/measurement-units`} className="btn btn-secondary">
            <FontAwesomeIcon icon={faArrowLeft} className="me-2" /> Back to List
          </Link>
        </div>
      </div>

      <MeasurementUnitForm isEdit={true} slack={id} />
    </Container>
  );
};

export default MeasurementUnitEdit;
